module.exports = __webpack_public_path__ + "img/horizontal_board.06d0ad1d.png";